import { LOCAL_STORAGE } from 'app/commons/constants'
import { ICON_DELIVEREE_WHITE, ICON_TRANSPORTIFY_WHITE } from 'app/commons/constants/image.const'

import React from 'react'

const Loading = (props: { isOpen: boolean }) => {
  const { isOpen } = props
  const countryCode = localStorage.getItem(LOCAL_STORAGE.DEFAULT_COUNTRY)

  return (
    <div className={`vertical-scroll Modal ${isOpen ? 'visible' : ''}`} id="loading-modal">
      <div className="locating-drivers">
        <div className="Loader">
          <div className="Loader-Icon">
            <div className="Logo">
              <img
                src={countryCode === 'ph' ? ICON_TRANSPORTIFY_WHITE : ICON_DELIVEREE_WHITE}
                alt="Icon deliveree white"
              />
            </div>
          </div>
        </div>
        <div className="progress-loading-container" id="progress-loading-container-id">
          <div id="progress-loading">
            <div id="bar-percent"></div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Loading
